@if (isMultiSelectMode$ | async) {
  @let count = (selectedCount$ | async) ?? 0;
  <odx-bar>
    <button odxBarButton variant="small" (click)="deselectAll()">
      <odx-icon size="large" name="close"></odx-icon>
    </button>
    @if (count === 1) {
      <label odxBarLabel i18n="@@floorplan.multiSelectBar.itemSelected" class="label"
        ><span class="count">{{ count }}</span> Element ausgewählt</label
      >
    } @else {
      <label odxBarLabel i18n="@@floorplan.multiSelectBar.itemsSelected" class="label"
        ><span class="count">{{ count }}</span> Elemente ausgewählt</label
      >
    }
    <button
      odxBarButton
      [disabled]="count === 0"
      (click)="duplicateAll()"
      i18n-odxTooltip="@@floorplan.multiSelectBar.duplicate"
      odxTooltip="Auswahl duplizieren"
    >
      <odx-icon size="large" name="copy-content"></odx-icon>
    </button>
    <button
      odxBarButton
      [disabled]="count === 0"
      (click)="groupAll()"
      [odxTooltip]="hasNonGroupableItems ? tooltipGroupDisabled : tooltipGroup"
    >
      <odx-icon iconSet="safety" size="large" name="group"></odx-icon>
    </button>
    <button
      odxBarButton
      [disabled]="count === 0"
      (click)="deleteAll()"
      i18n-odxTooltip="@@floorplan.multiSelectBar.delete"
      odxTooltip="Auswahl löschen"
    >
      <odx-icon size="large" name="delete"></odx-icon>
    </button>
  </odx-bar>
}
